/* eslint-disable no-unused-vars */
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

export const authAPI = createApi({
  reducerPath: 'AuthAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '' }),
  endpoints: (builder) => ({
    AdminLogout: builder.mutation({ query: () => ({ url: 'api/Account/logout', method: 'POST' }) }),
    GoogleLogin: builder.mutation({
      query: (data) => ({
        //url: 'http://localhost:3000/api/account/googleAuth',
        url: 'api/account/googleAuth',
        //url: 'https://apiv2.selfservice3.appnext.com/api/account/googleAuth',
        method: 'POST',
        data,
      }),
    }),
    UserLogin: builder.mutation({
      query: (data) => ({
        url: 'api/account/checkUserAuth',
        method: 'POST',
        data,
      }),
    }),
    VerifyLogin2fa: builder.mutation({
      query: (data) => ({
        url: 'api/Account/VerifyLogin2fa',
        method: 'POST',
        data,
      }),
    }),
    ResendLogin2fa: builder.mutation({
      query: (data) => ({
        url: 'api/Account/ResendLogin2fa',
        method: 'POST',
        data,
      }),
    }),
    SwitchUser: builder.mutation({
      query: (data) => ({
        url: 'api/Account/SwitchUser',
        method: 'POST',
        data,
      }),
    }),
    // user sign up
    UserSignup: builder.mutation({
      query: (data) => ({
        url: 'api/account/UserSignup',
        method: 'POST',
        data,
      }),
    }),
    ResendUserSignUpEmail: builder.mutation({
      query: (data) => ({
        url: 'api/account/ResendUserSignUpEmail',
        method: 'POST',
        data,
      }),
    }),
    ActivateUser: builder.mutation({
      query: (data) => ({
        url: 'api/account/ActivateUser',
        method: 'POST',
        data,
      }),
    }),
    // forgot password
    UserForgotPassword: builder.mutation({
      query: (data) => ({
        url: 'api/account/ForgotPassword',
        method: 'POST',
        data,
      }),
    }),
    ResendForgotPasswordEmail: builder.mutation({
      query: (data) => ({
        url: 'api/account/ResendForgotPasswordEmail',
        method: 'POST',
        data,
      }),
    }),
    ValidateForgotPassword: builder.mutation({
      query: (data) => ({
        url: 'api/account/ValidateForgotPassword',
        method: 'POST',
        data,
      }),
    }),
    ChangeForgotenPassword: builder.mutation({
      query: (data) => ({
        url: 'api/account/ChangeForgotenPassword',
        method: 'POST',
        data,
      }),
    }),
  }),
});
